
<div class="docReq alert-warning">
  <p><b>Request received:</b> smartData wants to associate with you for schedule a surgery.</p>
  <div class="">
    <button mat-button color="primary" (click)="openScheduleCase()">View request</button>
  </div>
</div>

<mat-card class="titleBar filter" >


    <div class="all">
        <button mat-flat-button [matMenuTriggerFor]="notification" class="user-button">
           All <mat-icon>keyboard_arrow_down</mat-icon>
          </button>
          <mat-menu class="customPanel" #notification="matMenu">
            <mat-card class="filterOption">
                <div class="fillist">
                    <label>Facility Name</label>
                    <div class="filterlist">                
                      <ng-container >                 
                        <div class="lList"><span class="name" >Green Care</span> </div>   
                        <div class="lList"><span class="name" >Home Care</span> </div>       
                      </ng-container>
                    </div>
                </div>
                <div class="fillist">
                    <label>Saved Filter</label>
                    <div class="filterlist">                
                      <ng-container >                 
                        <div class="lList"><span class="name" >Filter 1</span> </div>   
                        <div class="lList"><span class="name" >Filter 2</span> </div>       
                      </ng-container>
                    </div>
                </div>
            </mat-card>
          </mat-menu>
    </div>
  </mat-card>

  <table class="table" >
    <tr>
        <th>Procedure</th>
        <th>Rooms</th>
        <th>Date</th>
        <th>Time</th>
        <th>Duration</th>
        <th>Surgeon</th>
        <th>Anesthesia</th>
        <th>Monitoring</th>
        <th>Case</th>
        <th>Preference Card</th>
        <th>Description</th>
        <th>Tags</th>
        <th></th>
    </tr>
    <tr>
        <td><a href="javascript:(void)"  >Debridement of wound, burn, or infection</a> </td>
        <td><a href="javascript:(void)" >F1-1</a> </td>
        <td>18 Dec, 20</td>
        <td>6:00 AM - 8 AM</td>
        <td> 2 hr</td>
        <td>M.Mcalpin</td>
        <td>Yes</td>
        <td>Yes</td>
        <td>  
          <a href="javascript:(void)"  >Wound surgery along …</a>
        </td>
        <td>
          <a href="javascript:(void)"  >Mk Surgery</a>
        </td>
        <td>Description</td>
        <td>
          <div class="tagHolder">
            <span class="t1" >TU</span>
            <span class="t2">MK</span>
          </div>
        </td>
        <td>
            <mat-form-field class="selectBtn">
                <mat-label>Request Status</mat-label>
                <select matNativeControl required>
                  <option value="Pending">Pending</option>
                  <option value="Approved">Approved</option>
                  <option value="Reject">Reject</option>
                </select>
            </mat-form-field>         
        </td>
    </tr>
    <tr>
        <td><a href="javascript:(void)"  >Debridement of wound, burn, or infection</a> </td>
        <td><a href="javascript:(void)"  >F1-1</a> </td>
        <td>18 Dec, 20</td>
        <td>6:00 AM - 8 AM</td>
        <td> 2 hr</td>
        <td>M.Mcalpin</td>
        <td>Yes</td>
        <td>Yes</td>
        <td>  
          <a href="javascript:(void)"  >Wound surgery along …</a>
        </td>
        <td>
          <a href="javascript:(void)"  >Mk Surgery</a>
        </td>
        <td>Description</td>
        <td>
          <div class="tagHolder">
            <span class="t1" >TU</span>
            <span class="t2">MK</span>
          </div>
        </td>
        <td>
            <mat-form-field class="selectBtn">
                <mat-label>Request Status</mat-label>
                <select matNativeControl required>                    
                  <option value="Pending">Pending</option>
                  <option value="Approved">Approved</option>
                  <option value="Reject">Reject</option>
                </select>
            </mat-form-field>         
        </td>
    </tr>
    <tr>
        <td><a href="javascript:(void)"  >Debridement of wound, burn, or infection</a> </td>
        <td><a href="javascript:(void)" >F1-1</a> </td>
        <td>18 Dec, 20</td>
        <td>6:00 AM - 8 AM</td>
        <td> 2 hr</td>
        <td>M.Mcalpin</td>
        <td>Yes</td>
        <td>Yes</td>
        <td>  
          <a href="javascript:(void)"  >Wound surgery along …</a>
        </td>
        <td>
          <a href="javascript:(void)"  >Mk Surgery</a>
        </td>
        <td>Description</td>
        <td>
          <div class="tagHolder">
            <span class="t1" >TU</span>
            <span class="t2">MK</span>
          </div>
        </td>
        <td>
            <mat-form-field class="selectBtn">
                <mat-label>Request Status</mat-label>
                <select matNativeControl required>
                    <option value="Pending">Pending</option>
                    <option value="Approved">Approved</option>
                    <option value="Reject">Reject</option>
                </select>
            </mat-form-field>         
        </td>
    </tr>
</table>

<app-add-facility [ngClass]="{'open': showAddfacility}"  (CloseAddfacility)=getCloseAddfacility($event)></app-add-facility>